import React, { useState } from "react";
import { useUserTaskContext } from "../context";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import { DataGrid } from "@mui/x-data-grid";
import { autoSizeOptionsForDataGrid } from "constants/componentsConstants";
import { UsersTaskListGridColumns } from "./UsersTaskListGridColumns";
import { dataGridState } from "constants/dataGridConstants";

export const UserTaskDataGrid = () => {
  const { list } = useUserTaskContext();
  const [sortableRecords, setSortableRecords] = useState(list);

  return (
    <FlexBox justifyContent="space-between">
      <DataGrid
        sx={{
          "& .MuiDataGrid-columnHeader": {
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
          "& .MuiDataGrid-cell": {
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }}
        rows={sortableRecords}
        getRowHeight={() => "auto"}
        disableRowSelectionOnClick
        autosizeOnMount
        autosizeOptions={autoSizeOptionsForDataGrid}
        columns={UsersTaskListGridColumns({ list, setSortableRecords })}
        initialState={dataGridState.initialState}
        pageSizeOptions={dataGridState.pageSizeOptions}
        disableColumnMenu
      />
    </FlexBox>
  );
};
